import classNames from 'classnames';
import { Heading } from 'yoso';
import { BaseCard, BaseCardProps } from '~/components/Card';
import { T } from '~/components/I18n';
import { Exclamation } from '~/components/Icon';
import { Chevron } from '~/components/Icon/v2/Chevron';
import styles from './W8benCard.module.scss';

export type W8benCardProps = {
  className?: string;
} & BaseCardProps;

export const W8benCard = ({ className, ...props }: W8benCardProps) => (
  <BaseCard color="muted" className={classNames(styles.root, className)} {...props}>
    <div className={styles.aside}>
      <Exclamation className={styles.icon} />
    </div>
    <div className={styles.body}>
      <Heading className={styles.heading} level={4}>
        <T name="citizen_button_title_w8ben2" />{' '}
        <Chevron className={styles.chevron} direction="right" />
      </Heading>
      <p className={styles.description}>
        <T name="citizen_land_join_complete_w8ben_popup_desc3" />
      </p>
    </div>
  </BaseCard>
);
